import { $host, $authHost } from './index'
import { httpPoint } from '../utils/const'

export const generateQR = async (formData) => {
    const { data } = await $authHost.post(httpPoint.qr + 'generate', formData)
    return data
}